import { useScrollLock } from "@/hooks/useScrollLock";
import { Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

interface AuditStatusModalProps {
  open: boolean;
  onClose: () => void;
  auditStatus: string; // '0' 已提交待审批, '1' 已审批通过, '2' 拒绝审批
}

export const AuditStatusModal: React.FC<AuditStatusModalProps> = ({
  open,
  onClose,
  auditStatus,
}) => {
  const { t } = useTranslation();

  // 防止移动端滚动穿透
  useScrollLock(open);
  // 根据审核状态确定标题和内容
  const getStatusInfo = () => {
    switch (auditStatus) {
      case "0":
        return {
          title: t("common.modals.audit_title"),
          statusText: t("common.modals.audit_pending_status"),
          content:
            "您已提交申请，专属客服将在24小时内尽快与您联系。感谢您的关注～",
          color: "#1890ff", // 蓝色
        };
      case "1":
        return {
          title: t("common.modals.audit_title"),
          statusText: t("common.modals.audit_approved_status"),
          content:
            "您已通过内测申请，可进入【品牌AI指数】查看报告。如有疑问，请联系专属客服。",
          color: "#52c41a", // 绿色
        };
      case "2":
        return {
          title: t("common.modals.audit_title"),
          statusText: t("common.modals.audit_rejected"),
          content:
            "您需要申请内测，请联系邮箱:info@gen-optima.com，反馈您的需求。我们将在24小时与您联系。感谢您的关注～",
          color: "#ff4d4f", // 红色
        };
      default:
        return {
          title: t("common.modals.audit_title"),
          statusText: t("common.modals.audit_unknown_status"),
          content: "无法获取申请状态，请稍后重试。",
          color: "#000000", // 黑色
        };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[]}
      title={statusInfo.title}
      centered
    >
      <div style={{ padding: "20px 0" }}>
        <p>
          <strong>{t("common.modals.audit_progress_label")}</strong>
          <span style={{ color: statusInfo.color, fontWeight: "bold" }}>
            {statusInfo.statusText}
          </span>
        </p>
        <p>{statusInfo.content}</p>
      </div>
    </Modal>
  );
};

export default AuditStatusModal;
